<template>
  <div class="position-relative pb-5">
    <div class="component-body-tests bg-white shadow-sm p-4 p-md-5 mt-4">
      <LoaderContent
        v-if="isLoading"
        :welcomeMessage="false"
        :alignSpinnerTop="true"
      />

      <!-- Já está inscrito, mas ainda nåõ finalizou todos os testes -->
      <div class="text-center mb-5" v-if="isEnrolled && !allDone">
        <alert-circle-icon style="font-size: 80px" class="text-red-ml" />
        <h3>Finalize os testes abaixo para continuar sua inscrição</h3>
      </div>

      <!-- Já está inscrito e finalizou todos os testes -->
      <div class="text-center mb-5" v-if="isEnrolled && allDone">
        <h3>Você já está inscrito nessa oportunidade</h3>
      </div>

      <!-- Não está inscrito -->
      <div class="text-center mb-5" v-if="!isEnrolled">
        <alert-circle-icon style="font-size: 80px" class="text-red-ml" />
        <h3>Finalize os testes abaixo para continuar sua inscrição</h3>
      </div>

      <div
        class="d-flex align-items-center p-3 bg-light-2 shadow-sm mb-4"
        v-for="(test, i) in tests"
        v-if="test.hide_to_candidate == false"
      >
        <file-document-outline-icon
          class="mr-2"
          style="font-size: 30px"
          v-if="test.status == 'pending'"
        />
        <file-check-outline-icon
          class="mr-2 text-green-ml"
          style="font-size: 30px"
          v-if="test.status == 'finished'"
        />

        <div class="mr-2">
          <h6>{{ test.name }}</h6>
          <span v-if="test.status == 'pending'">Pendente</span>
          <span v-if="test.status == 'finished'">Finalizado</span>
        </div>

        <a v-if="test.test_id == 2015 || test.test_id == 2018" :href="'https://desafio-magalu.99jobs.com/?u=' + $store.state.user.profile.id" class="btn btn-blue-ml ml-auto d-flex align-items-center">
          Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </a>

        <router-link
          v-if="
            (test.test_id != 2015 && test.test_id != 2018) && 
            test.source == 'ninenine_jobs' &&
            test.status == 'pending'
          "
          :to="redirect(`${test.name}/${test.test_id}`)"
          class="btn btn-blue-ml ml-auto d-flex align-items-center"
        >
          Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </router-link>

        <button
          v-if="(test.test_id != 2015 && test.test_id != 2018) && test.source != 'ninenine_jobs' && test.status == 'pending'"
          @click="alertPartner(test.url)"
          class="btn btn-blue-ml ml-auto d-flex align-items-center"
        >
          Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </button>
      </div>
    </div>

    <button
      @click="subscription()"
      v-if="canSubmitForm"
      class="
        btn-submit btn btn-lg btn-blue-ml
        mx-auto
        d-flex
        align-items-center
        mt-5
      "
    >
      <span v-if="!isSaving">Finalizar Inscrição</span>
      <EllipsisLoader v-else />
    </button>
  </div>
</template>

<script>
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';
import FileAlertIcon from 'vue-material-design-icons/FileAlert.vue';
import FileCheckIcon from 'vue-material-design-icons/FileCheck.vue';
import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
import EllipsisLoader from '../Loader/EllipsisLoader.vue';
import LoaderContent from '../Loader/LoaderContent.vue';

export default {
  name: 'ComponentTests',

  data() {
    return {
      isLoading: false,
      tests: [],
      message: ' ',
      isSaving: false,
      opportunity: null,
      isEnrolled: false,
    };
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    },

    allDone() {
      return this.tests.filter((test) => test.status == 'pending').length == 0;
    },

    canSubmitForm() {
      // Se ele não estiver inscrito ainda
      // E
      // não tem nenhum teste pendente que seja obrigatório na inscrição
      return (
        !this.isEnrolled
        && this.tests.filter(
          (test) => test.status == 'pending' && test.required_in == 'subscription',
        ).length == 0
      );
    },

  },

  async mounted() {
    this.isLoading = true;

    await this.getOpportunity();

    this.$store
      .dispatch('tests/subscriptionTests', {
        opportunityId: this.opportunityId,
        finishedTests: true,
        requiredIn: 'subscription',
      })
      .then((tests) => {
        if (tests.error) {
          this.isLoading = false;
          this.$swal(
            'Uoops',
            'Ocorreu um erro ao carregar os testes da oportunidade. Tente novamente.',
            'error',
          );
          this.$router.push(`/vagas/${this.$route.params.id}/inscricao/`);
          return false;
        }

        this.tests = tests.subscriptionTests.json || [];

        var has2015pending = this.tests.find((t) => t.test_id == 2015 && t.status == 'pending') != null
        var has2018pending = this.tests.find((t) => t.test_id == 2018 && t.status == 'pending') != null

        // Se o teste 2015 e o 2018 estão pendentes, então remove um e exibe apenas o outro
        if(has2015pending && has2018pending){
          this.tests = this.tests.filter((t) => t.test_id != 2018)

          // CASO QUEIRA RENOMEAR O TESTE QUE APARECE, AQUI E O LUGAR
          this.tests = this.tests.map((t) => {
            if(t.test_id == 2015){
              t.name = 'Desafio Magalu';
            }
            return t;
          })
        }

        this.isLoading = false;

        if (this.tests.length == 0) this.subscription();
      })
      .catch((error) => {
        this.$swal(
          'Uoops',
          'Ocorreu um erro ao carregar os testes da oportunidade. Tente novamente...',
          'error',
        ).then(() => {
          this.isLoading = false;
          this.$router.push(`/vagas/${this.$route.params.id}/inscricao`);
        });
      });

    this.$store
      .dispatch('opportunities/isEnrolled', {
        opportunityId: this.opportunityId,
      })
      .then((response) => {
        this.isEnrolled = response.length > 0 && response.some((subscriptionResponse) => subscriptionResponse.step == 'applied');
      });
  },

  components: {
    LoaderContent,
    EllipsisLoader,
    AlertCircleIcon,
    FileAlertIcon,
    FileCheckIcon,
    FileDocumentOutlineIcon,
    FileCheckOutlineIcon,
    ChevronRightIcon,
  },

  methods: {
    async getOpportunity() {
      const opportunity = await this.$store.dispatch(
        'opportunities/getOpportunity',
        this.$route.params.id.match(/\d+/)[0],
      );
      if (opportunity) {
        this.opportunity = opportunity;
      }

      return opportunity;
    },

    alertPartner(link) {
      this.$swal({
        title: 'Atenção',
        text: 'Você será direcionado para o site parceiro para realizar o teste.',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Fechar',
        confirmButtonText: 'Vamos lá!',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          window.open(link, '_blank');
        }
      });
    },

    redirect(testId) {
      window.afterTestBackTo = this.$route.fullPath;
      return `${testId}`;
    },

    async subscription() {
      this.isSaving = true;
      await this.subscribeUser();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
